//请自行添加语言资源
const driver = {
  driverName: '司机姓名',
  idCard: '身份证',
  mobile: '手机号',
  companyCode: '机构编号',
  companyName: '机构名称',
  carrierCode: '承运商编号',
  carrierName: '承运商名称',
  createTime: '创建时间',
  creator: '创建者',
  updateTime: '修改时间',
  updater: '修改者',

  company: '所属机构',
  useCompanyName: '使用机构',
  carrier: '所属承运商',
};
export default driver



// WEBPACK FOOTER //
// ./src/page/mdm/driver/lang/driver.zh.js